import Server from "../server";
import View from "../framework/view";
import {Order} from "../bo/order";
import template from "../../pugc/edit-order";
import {formToJson} from "../misc/utils";
import {App} from "../app/app";
import {isDelivery} from "../misc/orders";
import {autocomplete} from "../google/autocomplete";
import PlaceResult = google.maps.places.PlaceResult;

export class EditOrderView extends View {

    static classname = "edit-order-view";

    private readonly server = Server.instance();

    private app: App;

    private id: string;

    private originalOrder?: Order;
    private edittedOrder?: Order;

    private place?: PlaceResult;

    constructor(app: App, id: string) {
        super(EditOrderView.classname);
        this.app = app;
        this.id = id;
        this.refresh();
    }

    refresh() {
        const q_ = this.server.getOrder(this.id);
        q_.then((order) => {
            this.originalOrder = order;
            this.edittedOrder = this.pipe(order);
            this.update();
        });
    }

    private pipe(input: Order) : Order {
        const ser = JSON.stringify(input);
        const out = JSON.parse(ser) as Order;
        return out;
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            order: this.edittedOrder,
            originalOrder: this.originalOrder,
        };

        const out = this.pug(template, data);

        this.edittedOrder && this.afterUpdate(() => {

            if (this.elt().data("initted")) {
                return;
            }
            this.elt().data("initted", true);

            this.elt().find("input.datefield").datefield({startDay: 1});

            const line1 = this.elt().find("input[name='shippingInfo.shipmentDetails.address.addressLine1']");

            line1.on("input", () => {
                this.elt().find(".autocompleted").text("");
                this.place = undefined;
            });

            if (line1.length > 0) {
                autocomplete(line1[0] as HTMLInputElement).then((autocomplete) => {
                    autocomplete.addListener("place_changed", () => {
                        this.place = autocomplete.getPlace();
                        console.log("Place changed", this.place);
                        const order = this.toOrder();
                        const address = isDelivery(order);
                        const autocompleted = (address && address.addressLine1) || "";
                        this.elt().find(".autocompleted").text(autocompleted);
                    });
                });
            }

        });

        return out;
    }

    toOrder() : Order {

        if (! this.originalOrder) {
            return {};
        }

        const x = this.toOrder0(false, this.pipe(this.originalOrder));
        const y = this.toOrder0(true);

        // Tweak buyerInfo
        // @ts-ignore

        const fixName = (originalName, xName, yName) => {
            const extractName = (nameObj: any) => {
                let out = nameObj?.firstName;
                if (nameObj?.lastName) {
                    out = out + " " + nameObj?.lastName;
                }
                return out;
            }

            // @ts-ignore
            const before = extractName(originalName);
            const after = extractName(yName);

            if (before && (before == after)) {
                // @ts-ignore
                xName.firstName = originalName.firstName;
                // @ts-ignore
                xName.lastName = originalName.lastName;
            } else {
                // @ts-ignore
                delete xName.lastName;
            }
        }

        // @ts-ignore
        fixName(this.originalOrder.buyerInfo, x.buyerInfo, y.buyerInfo);
        if (isDelivery(x)) {

            fixName(
                // @ts-ignore
                this.originalOrder.shippingInfo.shipmentDetails.address.fullName,
                // @ts-ignore
                x.shippingInfo.shipmentDetails.address.fullName,
                // @ts-ignore
                y.shippingInfo.shipmentDetails.address.fullName);
        }

        return x;
    }

    toOrder0(edited: boolean, order?: Order) : Order {
        const form = this.elt().find("form.edit-order-form");
        const data : any = {};
        formToJson(form, data);

        order = order || {};
        for (const key of Object.keys(data)) {

            if (data[key] === "" && key.indexOf("shippingInfo") > -1) {
                continue;
            }

            const bits = key.split(/\./);

            let target : any = order;
            for (let i = 0; i < bits.length; i++) {
                const bit = bits[i];
                if (i == bits.length - 1) {
                    target[bit] = data[key];
                    break;
                }

                if (target[bit] === undefined) {
                    if (isNaN(Number(bits[i+1]))) {
                        target[bit] = {};
                    } else {
                        target[bit] = [];
                    }
                }

                target = target[bit];
            }
        }

        const address = isDelivery(order);
        if (address) {

            address.business = this.elt().find("input[name='shippingInfo.shipmentDetails.address.business']").is(":checked");

            // Address has been updated, use it in the edited order

            if (! address.country) {
                address.country = "AU";
            }
            if (address.addressLine1 && edited) {
                address.addressLine1 = address.addressLine1.replace(/, Australia$/, "");
                delete address.city;
                delete address.zipCode;
            }
            if (this.place?.geometry?.location) {
                address.lat = this.place.geometry.location.lat();
                address.lng = this.place.geometry.location.lng();
                address.geocoded = true;
            }
            // @ts-ignore
            delete order.customField;

        } else {

            const originalAddress = this.originalOrder && isDelivery(this.originalOrder);
            if (originalAddress) {
                // Address was not modified, keep in new order. But propagate new name (shippingInfo.shipmentDetails.address.fullName)

                // @ts-ignore
                const fullName = order.shippingInfo.shipmentDetails.address.fullName;

                // @ts-ignore
                order.shippingInfo = order.shippingInfo || {};
                // @ts-ignore
                order.shippingInfo.shipmentDetails = order.shippingInfo.shipmentDetails || {};
                // @ts-ignore
                order.shippingInfo.shipmentDetails.address = originalAddress;
                // @ts-ignore
                order.customField = this.originalOrder?.customField;

                // @ts-ignore
                order.shippingInfo.shipmentDetails.address.fullName = fullName;
            }

        }

        return order;
    }

    save() {
        const order = this.toOrder();

        const add_ = this.server.editOrder(order);
        add_.then(() => {
            this.app.gotoUrl(`/orders/view/${order.id}`)
        });
    }

}


View.on(
    "." + EditOrderView.classname,
    "click",
    ".save",
    function(that: EditOrderView, event, elt) {
        event.preventDefault();
        that.save();
    });

